var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIntermodalArrowsCircleOrangeFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 18,
    fill: "#FF7A00"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.59 15.17L11.41 10L10 11.41L15.17 16.58L16.59 15.17ZM20.5 10L22.54 12.04L10 24.59L11.41 26L23.96 13.46L26 15.5V10H20.5ZM20.83 19.41L19.42 20.82L22.55 23.95L20.5 26H26V20.5L23.96 22.54L20.83 19.41Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntermodalArrowsCircleOrangeFilled);
export default __webpack_public_path__ + "static/media/intermodal-arrows-circle-orange-filled.0cd6c543.svg";
export { ForwardRef as ReactComponent };